// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Comment_wrapper__24GqP","userPhoto":"Comment_userPhoto__34IT1","message":"Comment_message__1vJg_","timestamp":"Comment_timestamp__1draL"};